import * as React from 'react'
import { compose } from 'redux'
import to from 'await-to-js'
import { connect } from 'react-redux'
import cookies from 'js-cookie'
import {
  Link,
  withRouter,
} from 'react-router-dom'
import {
  Field,
  reduxForm,
  getFormValues,
} from 'redux-form'
import {
  FIELDS,
  Constants,
  Props,
} from './types'
import InputField from '@App/components/fields/InputField'
import {
  SUBMIT,
  HOMEPAGE_ROUTE,
  COOKIES_AUTHORIZATION_TOKEN,
  BACK_TO_SIGN_IN_LINK,
} from '@App/constantes'
import {
  activateConfirmSecureUserAccount,
} from 'actions/profiles'
import { Button } from 'relevant-ui'

import 'components/forms/form.scss'
import { disable2FAConfirm, loginWith2FA } from '@App/store/user'

class Confirm2FAForm extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.state = {}

    this.onHandleSubmit = this.onHandleSubmit.bind(this)
    this.activateSecureAccount = this.activateSecureAccount.bind(this)
    this.login = this.login.bind(this)
    this.disable = this.disable.bind(this)
    this.onRedirectToConnectPath = this.onRedirectToConnectPath.bind(this)
  }

  async activateSecureAccount() {
    const { activateConfirmSecureUserAccount } = this.props

    const body = {
      code: this.props[FIELDS.SET_ACTIVATE_CODE],
    }

    const [, data]: any = await to(activateConfirmSecureUserAccount(body))

    if (data instanceof Error) {
      return
    }

    if (data && Object?.entries(data)?.length > 0) {
      this.props.history?.push(HOMEPAGE_ROUTE)

      return
    }

    return
  }

  onRedirectToConnectPath() {
    if (this.props.location.search.includes('redirect')) {
      if (this.props.location.search.split('redirect=')[1] !== undefined) {
        return (window.location.href = `${
          this.props.location.search.split('redirect=')[1]
        }`)
      }
    }

    return this.props.history?.push('/home')
  }

  async login() {
    const body = {
      email: this.props?.email,
      code: this.props[FIELDS.SET_ACTIVATE_CODE],
      rememberme: true,
    }

    if (cookies.get(COOKIES_AUTHORIZATION_TOKEN)) {
      const [, data]: any = await to(this.props.loginWith2FA(body) as any)

      if (data && Object?.entries(data)?.length > 0) {
        return this.onRedirectToConnectPath()
      }
    }
    return
  }

  async disable() {
    const { disable2FAConfirm } = this.props

    const body = {
      code: this.props[FIELDS.SET_ACTIVATE_CODE],
    }

    const [, data]: any = await to(disable2FAConfirm(body))

    if (data && Object?.entries(data)?.length > 0) {
      return this.onRedirectToConnectPath()
    }

    return
  }

  async onHandleSubmit(pEvt) {
    pEvt.preventDefault()

    if (this.props.isDisable) {
      return this.disable()
    }

    if (!this.props.isLogin) {
      return this.activateSecureAccount()
    }

    return this.login()
  }

  render() {
    const { pristine, submitting, isDisable } = this.props

    return (
      <form
        onSubmit={this.onHandleSubmit}>
        <div className="customform__row">
          <Field
            name={FIELDS.SET_ACTIVATE_CODE}
            label="Tapez le code reçu par SMS"
            component={InputField}
            primary
          />
          {!isDisable && (
            <div className="link">
              <Link
                to={HOMEPAGE_ROUTE}>
                {BACK_TO_SIGN_IN_LINK}
              </Link>
            </div>
          )}
        </div>
        <div className="wrapperButton">
          <Button
            button="primary"
            size="large"
            disabled={pristine || submitting}
            label={SUBMIT}
            onClick={this.onHandleSubmit}
          />
        </div>
      </form>
    )
  }
}

const mapStateToProps = (state: any) => {
  const values = getFormValues(Constants.FORM)(state)

  return {
    ...values,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    activateConfirmSecureUserAccount: body => dispatch(activateConfirmSecureUserAccount(body)),
    loginWith2FA: body => dispatch(loginWith2FA(body)),
    disable2FAConfirm: body => dispatch(disable2FAConfirm(body)),
  }
}

const NewConfirm2FAForm = reduxForm({
  form: Constants.FORM,
})(Confirm2FAForm as any)

export default compose<any>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(NewConfirm2FAForm)
